import { AmountRangeFormatters } from '../../../../shared/utilities/amount-range-formatters.js';
import { DateFormatters } from '../../../../shared/utilities/date-formatters.js';
import { EXCEPTION_REASONS } from '../../../types/arp/constants.js';

const formatDateRange = date => {
    const parsedDate = DateFormatters.parseDate(date);
    if (!parsedDate?.value) return undefined;
    if (typeof parsedDate.value === 'object') {
        return {
            startDate: parsedDate.value.start ?? undefined,
            endDate: parsedDate.value.end ?? undefined,
        };
    }
    return {
        startDate: parsedDate.value,
        endDate: parsedDate.value,
    };
};

const formatAmountRange = amount => {
    let startAmount;
    let endAmount;
    if (amount) {
        const rangeType = AmountRangeFormatters.getRangeType(amount);
        if (rangeType === 'AmountRange') {
            const amountRange = AmountRangeFormatters.getAmountStartAndEnd(amount);
            startAmount = amountRange.start ?? undefined;
            endAmount = amountRange.end ?? undefined;
        }
        if (rangeType === 'SpecificAmount') {
            const specificAmount = AmountRangeFormatters.getSpecificAmount(amount);
            startAmount = specificAmount ?? undefined;
            endAmount = specificAmount ?? undefined;
        }
        if (startAmount === undefined && endAmount === undefined) {
            return undefined;
        }
        return {
            startAmount,
            endAmount,
        };
    }
    return undefined;
};

export default class CheckExceptionMappings {
    static mapSearchParams(params) {
        const result = {
            accountUniqueIds: params?.account,
            checkNumber: params?.checkNumber || '',
            issuedAmount: formatAmountRange(params?.issuedAmount) ?? undefined,
            postedAmount: formatAmountRange(params?.paidAmount) ?? undefined,
            issuedDate: formatDateRange(params?.issuedDate) ?? undefined,
            issuedPayee: params?.issuedPayee || undefined,
            isPortrait: false,
        };

        if (params?.exceptionReasons && params?.exceptionReasons !== 'all') {
            if (params.exceptionReasons.length === EXCEPTION_REASONS.length) {
                result.exceptionReasons = undefined;
            } else {
                result.exceptionReasons = params.exceptionReasons;
            }
        }

        if (params?.postedDate) {
            result.postedDate = formatDateRange(params.postedDate) ?? undefined;
        }
        return result;
    }
}
